export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_ERROR = 'GET_EVENTS_ERROR';
export const NO_MORE_EVENTS = 'NO_MORE_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENT_NOTIFICATIONS = 'GET_EVENT_NOTIFICATIONS';
export const GET_EVENT_NOTIFICATIONS_ERROR = 'GET_EVENT_NOTIFICATIONS_ERROR';
export const GET_EVENT_NOTIFICATIONS_SUCCESS = 'GET_EVENT_NOTIFICATIONS_SUCCESS';
export const RESEND_EVENTS = 'RESEND_EVENTS';
export const RESEND_EVENTS_ERROR = 'RESEND_EVENTS_ERROR';
export const RESEND_EVENTS_SUCCESS = 'RESEND_EVENTS_SUCCESS';
export const RESOLVE_EVENTS = 'RESOLVE_EVENTS';
export const RESOLVE_EVENTS_ERROR = 'RESOLVE_EVENTS_ERROR';
export const RESOLVE_EVENTS_SUCCESS = 'RESOLVE_EVENTS_SUCCESS';